import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const checkoutUrl = 'https://checkout.tupuntodigital.online/checkouts/cn/hWN7KxpeGG27ZWP6JSh1M5Yo/es-ar?_r=AQABJ92B-oXw3u4aJaiQFH9rJBZPDCuWjsbIZv68OKhEceU&preview_theme_id=147264340118';
  return <a href={checkoutUrl} className={`
        group relative inline-flex items-center justify-center gap-2
        bg-gradient-to-r from-purple-600 to-indigo-600 
        hover:from-purple-500 hover:to-indigo-500
        text-white font-bold py-4 px-8 rounded-full 
        shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300
        text-lg md:text-xl uppercase tracking-wide
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} data-id="element-1">
      <span data-id="element-2">{children}</span>
      <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-3" />

      {/* Shine effect */}
      <div className="absolute inset-0 rounded-full overflow-hidden" data-id="element-4">
        <div className="absolute top-0 left-0 w-full h-full bg-white/20 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" style={{
        transform: 'skewX(-20deg)'
      }} data-id="element-5"></div>
      </div>
    </a>;
}